import { EntryScreen } from '@/components/visitone/entry-screen'
import { OperationFeedback } from '@/components/visitone/operation-feedback'
import { useT } from '@/components/visitone/visitone-provider'
import type { ConfigProblem } from '@/lib/config/runtime-config'

/*
 * Shown instead of the app when this deployment's /app-config.json is missing
 * or invalid (ADR-034). Auth0 is never initialised, so nobody is sent to a
 * tenant the deployment was not configured for. It names each field at fault;
 * the values themselves are never shown.
 */
export function StartupError({ problems }: { problems: ConfigProblem[] }) {
  const t = useT()
  return (
    <EntryScreen wide>
      <OperationFeedback
        state="error"
        pageHeading
        title={t('core.startup.title')}
        detail={t('core.startup.detail')}
        onRetry={() => window.location.reload()}
      />
      <section aria-labelledby="startup-problems" className="flex flex-col gap-2">
        <h2 id="startup-problems" className="text-sm font-medium text-fg-strong">
          {t('core.startup.problemsHeading')}
        </h2>
        <ul className="list-disc ps-5 text-sm text-fg wrap-anywhere">
          {problems.map((problem) => (
            <li key={`${problem.field}-${problem.reason}`}>
              {t(`core.startup.reasons.${problem.reason}`, { field: problem.field })}
            </li>
          ))}
        </ul>
      </section>
    </EntryScreen>
  )
}
